import AuthUtil from "~/lib/auth";

export default function useIsAuthenticated() {
  const isAuthenticated = Boolean(AuthUtil.getToken());
  return { isAuthenticated };
}
